import { render, staticRenderFns } from "./GroupResultsModal.vue?vue&type=template&id=61472a43"
import script from "./GroupResultsModal.vue?vue&type=script&lang=ts"
export * from "./GroupResultsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports